import { render, staticRenderFns } from "./TableCompromiso.vue?vue&type=template&id=d9c56488&scoped=true&"
import script from "./TableCompromiso.vue?vue&type=script&lang=js&"
export * from "./TableCompromiso.vue?vue&type=script&lang=js&"
import style0 from "./TableCompromiso.vue?vue&type=style&index=0&id=d9c56488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c56488",
  null
  
)

export default component.exports